'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').service('activitySvc', activitySvc);

  activitySvc.$inject = ['httpSvc', '$localStorage', '$sessionStorage', '$q', 'NotifyingSvc', 'msAuth'];

  /**
   * A service to get all of the available activities.
   */
  function activitySvc(httpSvc, $localStorage, $sessionStorage, $q, NotifyingSvc, msAuth) {

    return {
      getHomeActivities: getHomeActivities,
      getActivities: getActivities,
      getActivitiesByTag: getActivitiesByTag,
      getActivitiesByTagWithMeta: getActivitiesByTagWithMeta,
      getActivity: getActivity,
      getTags: getTags,
      getYouthTags: getYouthTags,
      getAvailableYouthCategoryTags: getAvailableYouthCategoryTags,
      getSpiritualTags: getSpiritualTags,
      saveResponses: saveResponses,
      saveQuizScore: saveQuizScore,
      savePublicActivityResponses: savePublicActivityResponses,
      getActivityResponseSharedStatus: getActivityResponseSharedStatus,
      getUpNext: getUpNext,
      updateActivityStatus: updateActivityStatus,
      search: search,
      registerEventlisteners: registerEventlisteners,
      clearYouthActivityCacheListener: clearYouthActivityCacheListener,
      getRandomActivity: getRandomActivity
    };

    function registerEventlisteners() {
      [NotifyingSvc.EVENTS.USER_SIGNUP_COMPLETE, NotifyingSvc.EVENTS.USER_LOGIN_COMPLETE].forEach(function (evt) {
        return NotifyingSvc.subscribe(evt, function (event, data) {
          if (data) {
            savePublicActivityResponses();
          }
        });
      });
    }

    function getHomeActivities(type) {
      return httpSvc.get('/apiproxy/user/activities' + (type ? '?type=' + type : ''));
    }

    function getActivities() {
      return httpSvc.get('/apiproxy/user/activities');
    }

    function getActivitiesByTag(tag) {
      return getActivitiesByTagWithMeta(tag).then(function (dat) {
        return dat.activities;
      });
    }

    function getActivitiesByTagWithMeta(tag) {
      if (tag === 'all') {
        return httpSvc.get('/apiproxy/editor/activities').then(function (dat) {
          // Add the category
          return {
            activities: dat,
            shortName: 'All',
            label: 'All Activities'
          };
        });
      } else {
        return httpSvc.get('/apiproxy/user/activities/bytag/' + tag);
      }
    }

    function getActivity(shortName, version, language) {
      var accessUrl = msAuth.isLoggedIn() ? 'user' : 'public';
      //if there's a language and the user isn't logged in add it to the public url
      var resolvedLanguage = !msAuth.isLoggedIn() && language ? '&language=' + language : '';
      //if there's a version add it to the url
      var resolvedVersion = version ? '&version=' + version : '';
      // if bad shortname passed, set to empty string to preserve existing behaviour
      var lc = !shortName ? '' : shortName.toLowerCase();
      return httpSvc.get('/apiproxy/' + accessUrl + '/activities/' + lc + '?include=sections' + resolvedVersion + resolvedLanguage, {
        withCredentials: msAuth.isLoggedIn()
      });
    }

    function getYouthTags() {
      return httpSvc.get('/apiproxy/user/activities/tags/youth');
    }

    function getAvailableYouthCategoryTags() {
      var _omit = ['recent', 'trending', 'top', 'popular', 'lowmood', 'assessment'];
      return getYouthTags().then(function (resp) {
        return _.filter(resp, function (item) {
          return item.type === 'METADATA' && item.componentId && !_.includes(_omit, item.tag) && item.activities.length > 4;
        });
      });
    }

    function getSpiritualTags() {
      return httpSvc.get('/apiproxy/user/activities/tags/spiritual');
    }

    function getTags(filtered) {
      if (filtered && $sessionStorage.filteredYouthActivities) {
        return $q.when($sessionStorage.filteredYouthActivities);
      }
      return httpSvc.get('/apiproxy/user/activities/tags', {
        withCredentials: true,
        params: { filtered: filtered }
      }).then(function (resp) {
        $sessionStorage.filteredYouthActivities = resp;
        return resp;
      });
    }

    function clearYouthActivityCacheListener() {
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPTIN_UPDATE, function () {
        return delete $sessionStorage.filteredYouthActivities;
      });
    }

    function saveResponses(activity) {
      if (!msAuth.isLoggedIn() && !msAuth.isWriteOnlyUser()) {
        return saveResponseLocally(activity);
      } else {
        return httpSvc.post('/apiproxy/user/activities/responses?shared=' + activity.shared, activity).then(function (resp) {
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ACTIVITY_COMPLETE, {
            activity: activity
          });
          return resp;
        }, function () {
          //fail gracefully if we have a bad token
          return saveResponseLocally(activity);
        });
      }
    }

    function saveResponseLocally(activity) {
      //if the user is not logged in, we should cache the activity response for later saving
      $localStorage.cachedActivityResponses = $localStorage.cachedActivityResponses || [];
      $localStorage.cachedActivityResponses.push(activity);
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ACTIVITY_COMPLETE, {
        activity: activity
      });
      return $q.when();
    }

    function saveQuizScore(quizScore) {
      return httpSvc.post('/apiproxy/user/quiz/score', quizScore);
    }

    function savePublicActivityResponses() {
      var promises = [];
      if ($localStorage.cachedActivityResponses && $localStorage.cachedActivityResponses.length > 0) {
        $localStorage.cachedActivityResponses.forEach(function (act) {
          promises.push(saveResponses(act));
        });
      }
      $q.all(promises).then(function () {
        return delete $localStorage.cachedActivityResponses;
      });
    }

    function updateActivityStatus(activityResponseId, shared) {
      return httpSvc.post('/apiproxy/user/activities/responses/' + activityResponseId + '/status/' + shared);
    }

    function getActivityResponseSharedStatus(activityResponseId) {
      return httpSvc.get('/apiproxy/user/activities/responses/' + activityResponseId + '/status');
    }

    function getRandomActivity() {
      return httpSvc.get('/apiproxy/user/activities/random?include=sections');
    }

    function getUpNext(currentActivity) {
      // if the activity has a related tag, we use that to find next - otherwise random list
      // TODO switch to related content id
      var res = currentActivity.relatedContentTag ? getActivitiesByTag(currentActivity.relatedContentTag.tag) : getHomeActivities('youth');
      return res.then(function (resp) {
        // filter out the current activity
        return resp.filter(function (activity) {
          return activity.url !== currentActivity.url;
        });
      });
    }

    function search(body) {
      var _body = angular.copy(body);
      if (!_body.size) {
        _body.size = 200;
      }
      if (!_body.from) {
        _body.from = 0;
      }
      _body.context = body.context === 'youth' ? ['youth'] : ['core', 'core_article', 'core_inspiration'];
      return httpSvc.post('/apiproxy/user/activities/search', _body).then(function (resp) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.SEARCH_RESULTS, {
          query: _body.query,
          context: _body.context,
          hits: resp.hits.total,
          records: resp.hits.hits
        });
        return resp;
      });
    }
  }
})();